import { ref } from 'vue'
import { getVersion } from '@/api'

// The bot's username, for links into its chat. It comes with `GET /version`; one request is shared by every caller.
// Stays empty until loaded and after a failure, so a command is then shown as plain text.
const botUsername = ref('')
let loading: Promise<void> | null = null

export function loadBotUsername(): Promise<void> {
  if (!loading) {
    loading = getVersion().then(
      (info) => {
        botUsername.value = info.bot_username ?? ''
      },
      () => {
        loading = null
      },
    )
  }
  return loading
}

export function useBotUsername() {
  void loadBotUsername()
  return botUsername
}

export function resetBotUsername(): void {
  botUsername.value = ''
  loading = null
}
